import { notifierServerAddress } from "../helpers/utils";
import { CancelablePromise, NjNotifierClient, SubscriptionRequest } from '../http/nj-notifier';

export class NotifierService {

	private static _instance: NotifierService;

	static get instance(): NotifierService {
		if (!this._instance) {
			this._instance = new NotifierService(notifierServerAddress());
		}
		return this._instance;
	}

	private readonly client: NjNotifierClient;

	constructor(baseUrl: string) {
		this.client = new NjNotifierClient({
			BASE: baseUrl,
		});
	}

	subscribe(request: SubscriptionRequest): CancelablePromise<any> {
		return this.client.default.subscribe(request);
	}

	confirm(uuid: string): CancelablePromise<any> {
		return this.client.default.confirm(uuid);
	}

	unsubscribe(uuid: string): CancelablePromise<any> {
		return this.client.default.unsubscribe(uuid);
	}
}
